import styled from 'styled-components';
import { TableCell, TableRow } from '@material-ui/core';
import React from 'react';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { SCheckbox } from './BCommonComponents';

export const STableHead = styled(TableCell)<{ bgcolor?: string }>`
--bg: ${props => {
	switch (props.bgcolor) {
		case 'primary':
			return "#D8E4F8"
		case 'secondary':
			return "#E6E8EB"
		default:
			return "#D8E4F8"
	}
}};
color:#002C74 !important;
background-color:var(--bg) !important;
text-transform: uppercase !important;
font-weight: 600 !important;
height: 45px !important;
`;
export const STableCell = styled(TableCell)<{ color?: string }>`
--color: ${props => {
	switch (props.color) {
		case 'primary':
			return "#002C74"
		case 'secondary':
			return "#25213B"
		default:
			return "#25213B"
	}
}};
color:var(--color) !important;
font-weight: 400;
`;

export const STableRow = styled(TableRow)`
&& {
background-color:#ffffff;
border-radius:3px;
}
`;

export const STablePaginationContainer2 = styled.div<{ disable: boolean }>`
--color: ${props => {
	if (props.disable) {
		return 'disable';
	}
	return '';
}};

    & * {
        pointer-events: none;
    		color: #ccc;
    }
`;

export const STablePaginationContainer = styled.div<{ disable: boolean }>`
${props => {
	if (props.disable) return `
            & * {
        pointer-events: none;
    		color: #ccc;
    }
        `
}}
`;

export type Order = 'asc' | 'desc';

export interface HeadCell {
	disablePadding: boolean;
	id: string;
	label: string;
	numeric: boolean;
	sortable: boolean;
}

interface STableProps {
	numSelected: number;
	onRequestSort?: (event: React.MouseEvent<unknown>, property: string) => void;
	onSelectAllClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	order?: Order;
	orderBy?: string;
	rowCount: number;
	headCells: HeadCell[];
	addCheckbox: boolean;
	bgcolor: string;
	sortable: boolean;
	checkboxDisabled?: boolean;
	disableAction: boolean;
}

export function STableHeader(props: STableProps) {
	const {onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, bgcolor, sortable, checkboxDisabled, disableAction} = props;
	const createSortHandler = (property: any) => (event: React.MouseEvent<unknown>) => {
		if (onRequestSort) {
			onRequestSort(event, property);
		}
	};

	return (
		<TableHead>
			<TableRow>
				{props.addCheckbox &&
				<STableHead padding="checkbox" bgcolor={bgcolor}>
					<SCheckbox
						indeterminate={numSelected > 0 && numSelected < rowCount}
						checked={rowCount > 0 && numSelected === rowCount}
						onChange={onSelectAllClick}
						disabled={checkboxDisabled}
						inputProps={{'aria-label': 'select all'}}
					/>
				</STableHead>
				}

				{props.headCells.map((headCell) => (
					<STableHead
						key={headCell.id}
						align={headCell.numeric ? 'right' : 'left'}
						padding={headCell.disablePadding ? 'none' : 'default'}
						sortDirection={orderBy === headCell.id ? order : false}
						bgcolor={bgcolor}
					>
						{(sortable && order && orderBy && headCell.sortable) ?
							<TableSortLabel
								active={orderBy === headCell.id}
								direction={orderBy === headCell.id ? order : 'asc'}
								onClick={createSortHandler(headCell.id)}
								disabled={disableAction}
							>
								{headCell.label}
							</TableSortLabel>
							:
							headCell.label
						}

					</STableHead>
				))}
			</TableRow>
		</TableHead>
	);
}
